
import api from 'igolf/users/api';

export default {
	async fetchBuddyList({ commit })
	{
		var result = await api.get('/buddies');
		commit('setBuddyList', result.data.buddies);
	},
}